export default __webpack_public_path__ + "static/media/kinga2.423f4be9.png";